module.exports = __webpack_public_path__ + "11gonggongxinxi";